export default __webpack_public_path__ + "static/video-32e52f5a9d504b3553467187392c862d.svg";